<section *ngIf="loaded && notFound" [dir]="isRtl? 'rtl':'ltr'">
  <div class="container px-lg-0 text-center py-5">
    @if (isUnified) {
    <h1 class="mb-3 uc-display-xs uc-medium" translate="emptyState.profileNotFound"></h1>
    } @else {
    <h3 class="mb-3" translate="emptyState.profileNotFound"></h3>
    }
    <p class="text-muted mb-4" translate="emptyState.profileNotFoundMessage"></p>
    <a class="btn btn-show-courses shadow-none d-inline-flex align-items-center justify-content-center"
       routerLink="/home" translate="emptyState.backToHome"></a>
  </div>
</section>
<section *ngIf="!notFound" [dir]="isRtl? 'rtl':'ltr'">
  <article>
    <div class="container px-lg-0">
      <div class="d-lg-flex">
        <div class="about-user-profile d-flex flex-column align-items-center justify-content-evenly">
          <div class="about-user-profile-info text-center">
            <app-avatar [src]="isInstructor ? (profileData.profilePicture ? resourse + profileData.profilePicture : null) : (profileData.logo ? resourse + profileData.logo : null)"
              fallbackSrc="assets/imgs/avatar.jpg" [name]="isRtl ? profileData.nameAr : profileData.name"></app-avatar>
            @if (isUnified) {
            <h1 class="uc-text-lg uc-bold">{{isRtl ? profileData.nameAr : profileData.name}}</h1>
            } @else {
            <h5>{{isRtl ? profileData.nameAr : profileData.name}}</h5>
            }
            <p *ngIf="isInstructor && profileData.jobClassificationId != 0">{{isRtl ?  jobDetails.nameAr : jobDetails.name}}</p>
            <div class="d-flex align-items-center justify-content-center">
              <button class="btn btn-follow shadow-none text-white d-flex align-items-center justify-content-center">
                <i class="fa-solid fa-plus"></i>
                <span translate="course.instructorPage.follow"></span>
              </button>
              <button *ngIf="profileData.courses?.length > 0" (click)="goDown()" class="btn btn-show-courses shadow-none d-flex align-items-center justify-content-center" translate="course.instructorPage.watchCourses"></button>
            </div>
          </div>
          <div class="line"></div>
          <ul class="m-0 align-self-start">
            <li *ngIf="isInstructor" class="d-flex align-items-center">
              <span class="icon-mask" style="mask-image: url(./../../../../assets/imgs/location.svg);"></span>
              <p class="mb-0">{{isRtl ? country?.nameAr : country?.name}} - {{isRtl ? region?.nameAr : region?.name}}   </p>
            </li>
            <li *ngIf="profileData.email" class="d-flex align-items-center">
              <span class="icon-mask" style="mask-image: url(./../../../../assets/imgs/email.svg);"></span>
              <a class="d-flex align-items-center" [href]="'mailto:' + profileData.email" target="_blank">{{profileData.email}} 
                <span class="icon-mask" style="mask-image: url(./../../../../assets/imgs/arrow-up-left.svg);"></span>
              </a>
            </li>
          </ul>
        </div>
        <div class="about-user-profile-details mt-4 mt-lg-0 d-lg-flex flex-column justify-content-between">
          <div>
            <h5 [translate]="isInstructor ? 'course.instructorPage.aboutInstructor' : 'course.instructorPage.aboutTrainingCenter'"></h5>
            <p>
              {{getDescription()}}
              <span *ngIf="currentHideDescription">
                <span *ngIf="toggleDescription">{{currentHideDescription}}</span>
                <button [dir]="isRtl ? 'ltr':'rtl'" (click)="toggleDescription = !toggleDescription" class="btn shadow-none border-0 p-0 m-0" [translate]="toggleDescription ? 'course.instructorPage.seeLess' : 'course.instructorPage.seeMore'"></button>
              </span>
            </p>
          </div>
          <ul class="d-lg-flex align-items-center justify-content-around">
            <li class="d-flex flex-column align-items-center">
              <span class="icon-mask" style="mask-image: url(./../../../../assets/imgs/star.svg);"></span>
              <h6>{{profileData.totalRate | number: '1.0-1'}}</h6>
              <p class="mb-0" [translate]="isInstructor ? 'course.instructorPage.coachEvaluation' : 'course.instructorPage.centerRating'"></p>
            </li>
            <li class="d-none d-lg-block">
              <div class="line"></div>
            </li>
            <li class="my-3 my-lg-0 d-flex flex-column align-items-center">
              <span class="icon-mask" style="mask-image: url(./../../../../assets/imgs/book.svg);"></span>
              <h6>{{profileData.totalCourses}}</h6>
              <p class="mb-0" translate="course.instructorPage.numberTrainingCourses"></p>
            </li>
            <li class="d-none d-lg-block">
              <div class="line"></div>
            </li>
            <li class="my-3 my-lg-0 d-flex flex-column align-items-center">
              <span class="icon-mask" style="mask-image: url(./../../../../assets/imgs/users.svg);"></span>
              <h6>{{profileData.totalStudents | number}}</h6>
              <p class="mb-0" translate="course.instructorPage.numberTrainees"></p>
            </li>
            <li class="d-none d-lg-block">
              <div class="line"></div>
            </li>
            <li class="d-flex flex-column align-items-center">
              <span class="icon-mask" style="mask-image: url(./../../../../assets/imgs/award.svg);"></span>
              <h6>{{profileData.totalRateNumber | number}}</h6>
              <p class="mb-0" translate="course.instructorPage.numberRatings"></p>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </article>
  <div class="container px-lg-0">
    <div *ngIf="isInstructor && (profileData.educations || profileData.userExperiences)" class="user-information">
      <div *ngIf="profileData.educations?.length > 0" [ngClass]="{'mb-0': profileData.userExperiences?.length > 0}" class="user-education">
        <div class="row">
          <div class="col-1"></div>
          <div class="col-11">
            <h5 translate="course.instructorPage.education"></h5>
          </div>
        </div>
        <div class="user-info-card row" *ngFor="let education of profileData.educations; first as first; last as last">
          <div class="col-1 overflow-hidden d-flex align-items-center justify-content-center">
            <div *ngIf="profileData.educations?.length > 1" class="user-stepper position-relative">
              <div *ngIf="first" class="top-line position-absolute w-100 start-50 translate-middle-x"></div>
              <div class="user-stepper-icon position-absolute py-2 start-50 translate-middle-x">
                <span class="icon-mask" style="mask-image: url(./../../../../assets/imgs/stepper.svg);"></span>
              </div>
              <div *ngIf="last" class="bottom-line position-absolute w-100 start-50 translate-middle-x"></div>
            </div>
          </div>
          <div class="col-11">
            <div class="user-card d-flex">
              <span class="icon-mask" style="mask-image: url(./../../../../assets/imgs/education.svg);"></span>
              <div>
                <h6>{{isRtl ? education.degreeNameAr : education.degreeName}}</h6>
                <p>{{isRtl ? education.schoolNameAr : education.schoolName}}</p>
                <span>{{education.endDate | date: 'MMMM YYYY'}} - {{education.startDate | date: 'MMMM YYYY'}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="profileData.userExperiences?.length > 0" class="user-experience">
        <div class="row">
          <div class="col-1"></div>
          <div class="col-11">
            <h5 translate="course.instructorPage.experience"></h5>
          </div>
        </div>
        <div class="user-info-card row" *ngFor="let experience of profileData.userExperiences; first as first; last as last">
          <div class="col-1 overflow-hidden d-flex align-items-center justify-content-center">
            <div *ngIf="profileData.userExperiences?.length > 1" class="user-stepper position-relative">
              <div *ngIf="first" class="top-line position-absolute w-100 start-50 translate-middle-x"></div>
              <div class="user-stepper-icon position-absolute py-2 start-50 translate-middle-x">
                <span class="icon-mask" style="mask-image: url(./../../../../assets/imgs/stepper.svg);"></span>
              </div>
              <div *ngIf="last" class="bottom-line position-absolute w-100 start-50 translate-middle-x"></div>
            </div>
          </div>
          <div class="col-11">
            <div class="user-card d-flex">
              <span class="icon-mask" style="mask-image: url(./../../../../assets/imgs/bag.svg);"></span>
              <div>
                <h6>{{isRtl ? experience.titleAr : experience.title}}</h6>
                <p>{{isRtl ? experience.employerNameAr : experience.employerName}}</p>
                <span>{{experience.endDate | date: 'MMMM YYYY'}} - {{experience.startDate | date: 'MMMM YYYY'}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="profileData.courses?.length > 0" id="courses" class="user-courses">
      <h3 translate="course.instructorPage.trainingCourses"></h3>
      <!-- <ul class="d-flex align-items-center">
        <li>
          <a class="active">جميع الدورات</a>
        </li>
        <li>
          <a>تصميم</a>
        </li>
        <li>
          <a>برمجة</a>
        </li>
        <li>
          <a>شبكات</a>
        </li>
      </ul> -->
      <div class="row row-cols-1 row-cols-md-2 row-cols-lg-4 gy-4">
        <div class="col" *ngFor="let course of courses">
          <app-course-item [course]="course" context="profile"></app-course-item>
        </div>
      </div>
      <button *ngIf="coursesCount < profileData.courses?.length" (click)="showMoreCourses()" class="btn shadow-none rounded-pill bg-white mx-auto d-flex align-items-center justify-content-center" translate="home.seeMore"></button>
      <button *ngIf="coursesCount > profileData.courses?.length && profileData.courses?.length > 4" (click)="hideCourses()" class="btn shadow-none rounded-pill bg-white mx-auto d-flex align-items-center justify-content-center" translate="course.instructorPage.seeLess"></button>
    </div>
  </div>
</section>